import React, { Component } from "react"
import "./ChooseModelModal.css"
import { getTranslation } from "../../assets/creator/translations"
import SalesModel from "../SalesModel/SalesModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { handleAcceptButton } from "../../utils/welcomePageUtils";

class ChooseModelModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedModel: "retail"
		}
	}

	handleReturnButton = () => {
		this.setState({ selectedModel: "retail" });
		this.props.handleIsEditedTemplate(false);
		this.props.handleIsShowWelcomeModal(true);
		this.props.handleIsShowChooseModelModal(false);
	}

	render() {
		return (
			!this.props.show ? null : (
				<div className='choose-model-modal'>
					<section className='choose-model-modal__main '>
						<div className='choose-model-modal__title'>
							{getTranslation("Msg_ChooseModelTitle")}
						</div>
						<div className='choose-model-modal__text'>
							<p>{getTranslation("Msg_ChooseModelText")}</p>
						</div>
						<div className="choose-model-modal__models">
							{this.state.selectedModel === "wholesale" ? (
								<div className="choose-model-modal__models-info">
									<FontAwesomeIcon icon={faInfo} className="choose-model-modal__models-info-icon" />
									<div className="choose-model-modal__models-info-text">
										{getTranslation("Msg_WholesaleInfo")}
									</div>
								</div>
							) : null}
							<div className="choose-model-modal__models-content">
								<SalesModel 
									modelTitle={getTranslation("Msg_RetailTitle")}
									modelText={getTranslation("Msg_RetailText")}
									isSelected={this.state.selectedModel === "retail" ? true : false}
									clickFunction={() => this.setState({ selectedModel: "retail" })}
								/>
								<SalesModel
									modelTitle={getTranslation("Msg_WholesaleTitle")}
									modelText={getTranslation("Msg_WholesaleText")}
									isSelected={this.state.selectedModel === "wholesale" ? true : false}
									clickFunction={() => this.setState({ selectedModel: "wholesale" })}
								/>
							</div>
						</div>
						<div className='choose-model-modal__btn-group'>
							<p className='welcome-modal__link continueEditProjectBtn' onClick={this.handleReturnButton}>
								{getTranslation("Btn_Return")}
							</p>
							<button
								className='choose-model-modal__btn choose-model-modal__btn--active chooseBtn'
								onClick={() => handleAcceptButton.call(this, true)}>
								{getTranslation("Btn_Confirm")}
							</button>
						</div>
						<span className="border-line"></span>
					</section>
				</div>
			)
		);
	}
}

export default ChooseModelModal



// WEBPACK FOOTER //
// ./src/components/ChooseModelModal/ChooseModelModal.js